import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ToastService {

	msg: IToastMessage | null = null;
	msgs: IToastMessage[] = [];
	timeout: number = 0;

	scheduledTimer: any;


	private _message: BehaviorSubject<ToastMessage> = new BehaviorSubject(new ToastMessage());
	public message: Observable<ToastMessage> = this._message.asObservable();

	constructor() { }

	show(message: string, type: ToastType = 'success', timeout = 1000, detail: string = null) {
		this.add({ message, type, timeout, detail });
		console.log('toast added', timeout);
	}

	add(toastMessage: IToastMessage) {
		this.msgs.push(toastMessage);

		if (this.timeout === 0) {
			this.popMessage();
		}
	}

	popMessage() {
		if (this.msgs.length === 0) {
			setTimeout(() => {
				this.msg = null;
				this.timeout = 0;

				this._message.next(new ToastMessage());
				console.log('cleared toast stack');
			}, 5);


			return;
		}

		const msg = this.msgs.shift();

		if (msg) {
			console.log('PUSH MESSAGE', msg);
			this.msg = msg;
			this.timeout = msg.timeout;

			this._message.next(new ToastMessage(msg.message, msg.type, msg.timeout, msg.detail));

			this.scheduledTimer = setTimeout(() => {
				this.popMessage();
			}, this.timeout);
		}
	}

	clear() {
		if (this.scheduledTimer) {
			clearTimeout(this.scheduledTimer);
			this.scheduledTimer = null;
			this.timeout = 0;
			console.log('toast cleared');
		}
		if (this.msgs.length > 0) {
			this.msgs = [];

		}
		this.popMessage();
	}
}

export interface IToastMessage {
	message: string,
	type: ToastType,
	timeout: number
	detail: string;
}

export class ToastMessage {
	message: string | null;
	detail: string | null;
	type: ToastType;
	timeout: number;

	constructor(message: string | null = null, type: ToastType = 'success', timeout: number = 3000, detail: string | null = null) {
		this.message = message;
		this.type = type;
		this.timeout = timeout;
		this.detail = detail;
	}
}

export type ToastType = 'success' | 'warn' | 'error';
